import React, { Component, useEffect, useRef, useState } from 'react';
import { jsx, css } from '@emotion/react';
import { fieldRow } from '../Styles';
import {
    Button, Radio, RadioGroup, FormControl, FormControlLabel,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper
} from '@material-ui/core';
import FormData from 'form-data';
import MappingFieldsOverLay from './MappingFieldsOverLay';
import './MappingFields.css';
import { UploadFile, GetMappingFields, DownloadMappedConfiguration, UploadMappedConfiguration } from '../../api/api';
import SubHeader from '../QuestionConfigure/SubHeader';
import { BsDownload, BsUpload } from 'react-icons/bs';
import { toast } from 'react-toastify';
const MappingScreen = (props) => {
    const [openOverLay, setOpenOverLay] = React.useState(false);
    const [selectedFile, setSelectedFile] = React.useState(null);
    const [uploadFileType, setUploadFileType] = React.useState("new");
    const [configType, setConfigType] = useState('1');
    const [customer, setCustomer] = useState();
    const [orgType, setOrgType] = useState();
    const [mappings, setMappings] = useState();
    const [existingMappingList, setExistingMappingList] = useState([]);
    const [showLoader, setLoader] = useState(false);
    const fileRef = useRef();
    //let { orgType, id } = props.match.params;

    //const { orgType, id } = useParams();

    useEffect(() => {
        let { id, Org, Config, subConfig, orgType } = props.match.params;
        setOrgType(orgType);
        setCustomer(id);

        GetMappingFields({ customer: id, config_type: Config, sub_config_type: subConfig }, function (response) {

            if (response.status == 'success') {
                setExistingMappingList(response.response);
            }
        });
    }, []);
    
    const openDialogue = () => {
        setOpenOverLay(!openOverLay);
    }

    const onFileChange = (file) => {
        file.preventDefault();
        let val = file.target.files[0];
        setSelectedFile(val);
    };

    const uploadfile = () => {
        if (!selectedFile) {
            toast.info(`Please select file to upload.`, { position: toast.POSITION.TOP_CENTER, autoClose: 3000 });
            return;
        }
        let { Config, subConfig } = props.match.params;
        let formData = new FormData();
        if (uploadFileType === "new") {
            formData.append("clients_file", selectedFile);
        } else {
            formData.append("config_file", selectedFile);
        }
        formData.append("config_type", Config);
        formData.append("sub_config_type", subConfig);
        formData.append("customer", customer);

        UploadFile(formData, uploadFileType, function (response) {
            //file.target.value = '';
            if (response && response.status == 'success') {
                var result = {
                    ConfiguredFields: response.response.config_properties,
                    FileFields: response.response.file_properties,
                    MappingSet: response.response.mapping_set,
                    TransactionId: response.response.transaction_id,
                    Customer: customer,
                    DistributionId: response?.response?.distribution_id
                };

                setMappings(result);
                setOpenOverLay(prev => !prev);

                if (fileRef) fileRef.current.value = '';
            }
            else {
                toast.error(response.message, { position: toast.POSITION.TOP_CENTER, autoClose: 5000 });
            }
        });
    };

    const onConfigChange = (event) => {
        var configVal = event.target.value;
        setConfigType(configVal);
    }

    const overLayCallBack = () => {
        let { id, Org, Config, subConfig, orgType } = props.match.params;
        GetMappingFields({ customer: customer, config_type: Config, sub_config_type: subConfig }, function (response) {

            if (response.status == 'success') {
                setExistingMappingList(response.response);
            }
        });
    }

    const tableRowClick = (row) => {
        var result = {
            ConfiguredFields: row.config_properties,
            FileFields: row.file_properties,
            MappingSet: row.mapping_set,
            TransactionId: row.id,
            Customer: customer,
            DistributionId: row?.distribution_id,
            IsApproved: row?.is_approved
        };

        setMappings(result);
        setOpenOverLay(prev => !prev);
    }

    const downloadConfiguration = async (e) => {
        e.preventDefault();
        let { id, Config, subConfig } = props.match.params;
        await DownloadMappedConfiguration(id, Config, subConfig)
    }

    let { id, Config, subConfig, subLabel } = props.match.params;

    return (
        <>
            <div css={fieldRow} style={{ justifyContent: 'center', marginTop: '30px' }}>
                <SubHeader {...props.match} title={`${subLabel} Mapping`} id={props.match.params.id} config={props.match.params.Config} subConfig={props.match.params.subConfig} DownloadToolConfiguration={() => { }} UploadToolConfiguration={() => { }} loadingHandler={() => { }} isLoading={() => { }} />

                <div style={{ textAlign: 'center' }} >
                    {orgType == '3' ?
                        <FormControl>
                            <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                                onChange={onConfigChange}
                                value={configType}
                            >
                                <FormControlLabel
                                    value="1"
                                    control={
                                        <Radio
                                            style={{
                                                color: '#007bff'
                                            }}
                                        />
                                    }
                                    label="Client"
                                />
                                <FormControlLabel
                                    value="2"
                                    control={
                                        <Radio
                                            style={{
                                                color: '#007bff'
                                            }}
                                        />
                                    }
                                    label="Family"
                                />
                            </RadioGroup>
                        </FormControl>
                        : ''}
                    <br />
                    {uploadFileType === "new" ? (
                        <label className='ml-3'>Upload external file and configure the mappings.</label>
                    ) : (
                        <label className='ml-3'>Upload existing internal mapped file.</label>
                    )}
                    <br />
                    <FormControl>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            onChange={(e) => setUploadFileType(e.target.value)}
                            value={uploadFileType}
                        >
                            <FormControlLabel
                                value="new"
                                control={
                                    <Radio
                                        style={{
                                            color: '#007bff'
                                        }}
                                    />
                                }
                                label="External File"
                            />
                            <FormControlLabel
                                value="existing"
                                control={
                                    <Radio
                                        style={{
                                            color: '#007bff'
                                        }}
                                    />
                                }
                                label="Existing File"
                            />
                        </RadioGroup>
                    </FormControl>
                    <br />
                    <input name="uploadfile" ref={fileRef} type="file" onChange={onFileChange} />
                    <Button
                        type="submit"
                        size="small"
                        variant="contained"
                        //disabled={this.state.isLoading}
                        onClick={uploadfile}
                        //onClick={openDialogue}
                        style={{
                            marginRight: 10,
                            backgroundColor: '#007bff',
                            color: '#fff'
                        }}
                    >
                        Upload
                    </Button>
                </div>

                <>
                    <br />
                    <br />
                    <TableContainer component={Paper} style={{ margin: '15px', width: 'auto' }}>
                        <Table aria-label="a dense table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>
                                        <b>ConfigType</b>
                                    </TableCell>
                                    <TableCell>
                                        <b>Created Date</b>
                                    </TableCell>
                                    <TableCell>
                                        <b>Action</b>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {existingMappingList && existingMappingList.length > 0 ? existingMappingList.map((row) => (
                                    <TableRow key={row.Id} style={{ height: '50px', cursor: 'pointer' }} onClick={(e) => { tableRowClick(row) }}>
                                        <TableCell style={{ padding: '5px 15px' }} component="td" scope="row">
                                            {row.config_type_name}
                                        </TableCell>
                                        <TableCell style={{ padding: '5px 15px' }} component="td" scope="row">
                                            {row.date_created}
                                        </TableCell>
                                        <TableCell style={{ padding: '5px 15px' }} component="td" scope="row">
                                            <button type="button" className="sub-button" data-toggle="tooltip"
                                                data-placement="top" title="Upload configuration" aria-label="Upload configuration"
                                                onClick={(e) => { e.stopPropagation(); downloadConfiguration(e); }}>
                                                <BsDownload className="btn-icon" />
                                                Download Configuration
                                            </button>
                                        </TableCell>
                                    </TableRow>
                                )) : <TableRow>
                                    <TableCell colSpan={2}>
                                        No Mapping Fields Config Found.
                                    </TableCell>
                                </TableRow>}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </>
            </div>
            {openOverLay ?
                <MappingFieldsOverLay mappingFields={mappings} isOpen={openOverLay} close={setOpenOverLay} callBack={overLayCallBack} Config={Config} subConfig={subConfig} customer={id} />
                : ''}
        </>
    )
}

export default MappingScreen;